enum AuthenticationType {
    Application = 0,
    Social = 1,
    Library = 2,
}

export { AuthenticationType };
